<template>
    <div class="snoop-cookie-details">
        <a
            :id="`js-snoop-cookie-${id}`"
            :href="`#${collapsibleId}`"
            role="button"
            :aria-expanded="isOpen ? 'true' : 'false'"
            :aria-controls="collapsibleId"
            class="qa-detail-toggle"
            @click.prevent="toggle"
        >
            <h4 class="snoop-cookie-details__trigger">
                <span class="snoop-cookie-details__trigger-headline">
                    <span v-if="hasCheckbox">
                        <snoop-checkbox
                            :id="`snoop-cookie-details-${id}`"
                            :value="value"
                            :label="headline"
                            :requires="requires"
                            :accepted-cookie-ids="acceptedCookieIds"
                            @input="$emit('input', $event)"
                        />
                    </span>
                    <span v-else class="snoop-cookie-details__headline-container">
                        <span class="snoop-checkbox__label">{{ headline }}</span>
                        <span>{{ subheadline }}</span>
                    </span>
                </span>

                <snoop-icon
                    name="pointer"
                    hidden
                    class="snoop-cookie-details__icon"
                    :rotate="isOpen ? 0 : 180"
                />
            </h4>
        </a>
        <slide-up-down :active="isOpen" :duration="500">
            <div
                v-show="isOpen"
                :id="collapsibleId"
                class="snoop-cookie-details__wrapper"
            >
                <slot />
            </div>
        </slide-up-down>
    </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'
import SnoopCheckbox from './Checkbox.vue'
import SnoopIcon from './Icon.vue'


export default {
    components: { SlideUpDown, SnoopCheckbox, SnoopIcon },

    props: {
        value: { type: Boolean, default: false },
        id: { type: String, required: true },
        headline: { type: String, required: true },
        subheadline: { type: String, default: '' },
        hasCheckbox: { type: Boolean, default: false },
        requires: { type: Array, default: () => [] },
        acceptedCookieIds: { type: Array, default: null },
    },

    data: () => ({ isOpen: false }),

    computed: {
        collapsibleId () {
            return `js-snoop-cookie-details-cookie-more-${this.id}`
        },
    },

    methods: {
        toggle () {
            this.isOpen = !this.isOpen
        },
    },
}
</script>
